module.exports = __webpack_public_path__ + "static/media/icon-contact-behance.874aeb82.svg";